import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import Layout from '../components/Layout';
import {
  Container,
  PageHeader as StyledPageHeader,
  PageTitle as StyledPageTitle,
  Text,
  Card
} from '../styles';
import {
  DashboardAvatar,
  UserInfo,
  UserDetails,
  UserTypeBadge,
  QuickActionsGrid,
  ActionCard
} from './DashboardPage.styles';

const DashboardPage: React.FC = () => {
  const { user } = useAuth();

  if (!user) {
    return <div>Carregando...</div>;
  }

  const getInitials = (nome: string) => {
    return nome
      .split(' ')
      .map(word => word.charAt(0))
      .join('')
      .toUpperCase()
      .slice(0, 2);
  };

  return (
    <Layout title="Dashboard">
      <Container>
        <StyledPageHeader>
          <StyledPageTitle>Bem-vindo ao SAGEx</StyledPageTitle>
          <Text size="lg" color="secondary">
            Sistema Expert em Gestão Escolar - Gerencie sua escola com eficiência
          </Text>
        </StyledPageHeader>

        <Card style={{ marginBottom: '30px' }}>
          <UserInfo>
            <DashboardAvatar type={user.tipo}>
              {getInitials(user.nome)}
            </DashboardAvatar>
            <UserDetails>
              <h3>{user.nome}</h3>
              <p>{user.email}</p>
              <UserTypeBadge type={user.tipo}>{user.tipo}</UserTypeBadge>
            </UserDetails>
          </UserInfo>
        </Card>

        <QuickActionsGrid>
          <ActionCard>
            <h4>Turmas</h4>
            <p>Gerenciar turmas e configurações acadêmicas</p>
          </ActionCard>
          
          <ActionCard>
            <h4>Alunos</h4>
            <p>Cadastro e importação de alunos</p>
          </ActionCard>
          
          <ActionCard>
            <h4>Responsáveis</h4>
            <p>Gestão de responsáveis financeiros</p>
          </ActionCard>
          
          <ActionCard>
            <h4>Mensalidades</h4>
            <p>Controle de pagamentos e gestão financeira</p>
          </ActionCard>
          
          {user.tipo === 'admin' && (
            <ActionCard>
              <h4>Usuários</h4>
              <p>Gerenciar usuários do sistema</p>
            </ActionCard>
          )}
        </QuickActionsGrid>
      </Container>
    </Layout>
  );
};

export default DashboardPage;
